import React from 'react';
import { Grid } from '@material-ui/core';
import { SearchBar, VideoList, VideoDetails } from './Components/index';
import mytube from './Api/mytube';

class App extends React.Component{

  state = {
     videos: [],
     selectedVideo: null,
  }

  handleSubmit = async(SearchTerm) =>{
     const response = await mytube.get('search',{
          params:{
            part: 'snippet',
            maxResults: 10,
            key: 'AIzaSyCwLgiei3PtNRDyq5PiY82q8VC_7eVjW7Q',
            q: SearchTerm,
        }
     });
     
     this.setState({
       videos: response.data.items,
       selectedVideo: response.data.items[0],
     })
    }

    onVideoSelect = (videos) =>{
        this.setState({
            selectedVideo: videos
        })
    }

  render(){
    
    const { selectedVideo, videos } = this.state;

    return(
      <Grid justify="center" container spacing={24}>
         <Grid item xs={12}>
            <Grid container spacing={24}>
              <Grid item xs={1}></Grid>
                <Grid item xs={10} style={{marginBottom:'50px', marginTop:'30px'}}>
                  {/* Search Bar */}
                   <SearchBar onFormSubmit={this.handleSubmit} />
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={6} style={{marginRight:'15px'}}>
                  {/* Video Details */}
                  <VideoDetails video={selectedVideo}/>
                </Grid>
                <Grid item xs={4}>
                  {/* Video Lists */}
                    <VideoList videos={videos} onVideoSelect={this.onVideoSelect}/>
                </Grid>
                <Grid item xs={1}></Grid>
            </Grid>
         </Grid>
      </Grid>
    )
  }
}

export default App;
